import { createAction, handleActions } from 'redux-actions';

export const types = {
  REMOVE_TOKEN: 'REMOVE_TOKEN',
  FORCE_LOGOUT: 'FORCE_LOGOUT',
  LOGOUT: 'LOGOUT',
};

export const forceLogout = createAction(types.FORCE_LOGOUT);
export const removeToken = createAction(types.REMOVE_TOKEN);
export const logout = createAction(types.LOGOUT);

const INIT_STATE = {
  token: '',
};

const reducer = handleActions(
  {
    [types.FORCE_LOGOUT]: () => ({
      token: '',
    }),
    [types.REMOVE_TOKEN]: () => ({
      token: '',
    }),
    [types.LOGOUT]: (state) => ({
      ...state,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getToken = (state) => state.auth.token;



// WEBPACK FOOTER //
// ./src/services/redux/auth.js